/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'billingSubscriptionPayments';

/** Fixed API base — not resolved from commercial billing nav `subscriptions`. */
export const API_ROUTE = 'billing/subscription-payments';

/** Singular entity name for shared helpers / notifications. */
export const ENTITY_NAME = 'billingSubscriptionPayment';

/** i18n resource key for form drawer hero summary. */
export const FORM_RESOURCE_KEY = 'billingSubscriptionPayments';

/** Frontend path for Automy attention queue. */
export const BILLING_SUBSCRIPTION_PAYMENTS_PATH = '/configuration/billing-subscription-payments';

/** Session-storage key prefix for stable claim idempotency keys. */
export const CLAIM_IDEMPOTENCY_STORAGE_PREFIX = 'billing-manual-claim-idempotency:';

export const PAYMENT_REVIEW_ACTION = Object.freeze({
  CONFIRM: 'confirm',
  REJECT: 'reject',
});

/** Manual claim providers only (Stripe is not a claim path). */
export const MANUAL_CLAIM_PROVIDERS = Object.freeze({
  BANK_TRANSFER: 'bank-transfer',
  MANUAL: 'manual',
});
